// src/admin/utils/phone.ts — +260 (Zambia) only for v1.

export function formatZambiaPhone(raw: string | null | undefined): string {
  if (!raw) return '—';
  // Normalise to digits
  const digits = raw.replace(/\D/g, '');
  // Expect 12 digits starting 260 OR 9/10-digit local
  let local: string;
  if (digits.startsWith('260') && digits.length === 12) local = digits.slice(3);
  else if (digits.length === 10 && digits.startsWith('0')) local = digits.slice(1);
  else if (digits.length === 9) local = digits;
  else return raw; // can't format, return as-is
  if (local.length !== 9) return raw;
  const net = local.slice(0, 2);
  const a = local.slice(2, 5);
  const b = local.slice(5);
  return `+260 ${net} ${a} ${b}`;
}

export function isValidZambiaPhone(raw: string | null | undefined): boolean {
  if (!raw) return false;
  const digits = raw.replace(/\D/g, '');
  // Must resolve to 9-digit local starting with 9 or 7 (MTN/Airtel/Zamtel prefixes)
  let local: string;
  if (digits.startsWith('260') && digits.length === 12) local = digits.slice(3);
  else if (digits.length === 10 && digits.startsWith('0')) local = digits.slice(1);
  else if (digits.length === 9) local = digits;
  else return false;
  return /^(9[5-7]|7[5-7])\d{7}$/.test(local);
}
